/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S1_P2Inputs */

const en_guide_what_is_json_s1_p2 = /** @type {(inputs: Guide_What_Is_Json_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A JSON object is enclosed in curly braces <code>&#123;&#125;</code> and contains key-value pairs separated by commas. Keys must be strings wrapped in double quotes, and values can be strings, numbers, booleans, null, arrays, or other objects.`)
};

const ko_guide_what_is_json_s1_p2 = /** @type {(inputs: Guide_What_Is_Json_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 객체는 중괄호 <code>&#123;&#125;</code>로 둘러싸여 있으며 쉼표로 구분된 키-값 쌍을 포함합니다. 키는 반드시 큰따옴표로 감싼 문자열이어야 하며, 값은 문자열, 숫자, 불리언, null, 배열 또는 다른 객체가 될 수 있습니다.`)
};

const ja_guide_what_is_json_s1_p2 = /** @type {(inputs: Guide_What_Is_Json_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONオブジェクトは波括弧<code>&#123;&#125;</code>で囲まれ、カンマで区切られたキーと値のペアを含みます。キーはダブルクォートで囲まれた文字列でなければならず、値は文字列、数値、ブーリアン、null、配列、または他のオブジェクトを指定できます。`)
};

/**
* | output |
* | --- |
* | "A JSON object is enclosed in curly braces <code>&#123;&#125;</code> and contains key-value pairs separated by commas. Keys must be strings wrapped in double ..." |
*
* @param {Guide_What_Is_Json_S1_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s1_p2 = /** @type {((inputs?: Guide_What_Is_Json_S1_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S1_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s1_p2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s1_p2(inputs)
	return ja_guide_what_is_json_s1_p2(inputs)
});